import React from 'react';
import { ReactComponent as CraneSVG } from '../assets/crane.svg';

const ConstructionPage = () => {
    return (
    <div className="text-white mt-[-96px] w-full h-screen flex flex-col items-center justify-center">
        <CraneSVG style={{ height: 200, width: 200 }} />
        <p className='text-2xl p-6'>This page is under construction. It would love to meet you when it's built!</p>
    </div>
    )
};

export default ConstructionPage;